module.exports = __webpack_public_path__ + "img/qr-svg.0ccc5475.svg";